import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ServicesService } from '~shared/servicios/services.service';
import { InicioNComponent } from '../inicio-n.component';

@Component({
  selector: 'app-billetera',
  templateUrl: './billetera.component.html',
  styleUrls: ['./billetera.component.scss']
})
export class BilleteraComponent extends InicioNComponent implements OnInit {

  Beneficios: any[] = [
    {
      id: 1,
      imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Seg-datos-new.png',
      titulo: 'Seguridad de datos',
      parrafo: 'Contamos con tecnología robusta que garantiza la seguridad de tu información'
    },
    {
      imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Soporte-new.png',
      titulo: 'Soporte',
      parrafo: 'Con Triidy podras contar con nuestro soporte de atención al cliente'
    },
    {
      imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Comunidad-new.png',
      titulo: 'Comunidad',
      parrafo: 'Forma parte de la comunidad de comercios electrónicos más grande de Colombia'
    },
    {
      imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/ProdGana-new.png',
      titulo: 'Productos ganadores',
      parrafo: 'Accede a los catálogos de artículos en tendencia de ventas por internet'
    },
    {
      imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Pagos-new.png',
      titulo: 'Pagos contra entrega',
      parrafo: 'Contamos con este método de pago para incrementar tus ventas hasta un 150%'
    },
    {
      imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Boost-new.png',
      titulo: 'Triidy Boost',
      parrafo: 'Adelantamos el dinero de tus ventas para que no pares de crecer'
    }
  ]

  Caracteristicas: any[] = [
    {
      id: 1,
      imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Carac1-new.png',
      titulo: 'Aceleración de recursos',
      texto: 'Sabemos que cuando inicias tu ecommerce o lo estás creciendo necesitarás dinero para acelerar tu camino, por eso cuando ingreses en Triidy te adelantamos $1.000.000 para que compres productos a los proveedores y puedas venderlos dropshipping. Igualmente si ya estás en etapa de crecimiento nuestro sistema de big data te ofrecerá recursos para que dupliques tus ventas.'
    },
    {
      imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Carac2-new.png',
      titulo: 'Comprar productos a los proveedores que están en Triidy o registrar tus propios proveedores',
      texto: 'Esto te permitirá ahorrar el 80% de tus costos operativos ya que no incurres en gastos de almacenaje de mercancia, manejo de inventario, personal operativo y te concentras en la tarea más importante que es vender. Si registras tu propio proveedor podrás  despachar tus ventas bajo el modelo dropshipping hacia el cliente final.'
    },
    {
      imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Carac3-new.png',
      titulo: 'Paga los envíos de tus ventas y recaudo de dinero',
      texto: 'Con nosotros puedes vender con servicio contraentrega en el 98% de los municipios en Colombia. Tus clientes pagarán la compra cuando el producto llegue. El dinero recaudado por la transportadora será debitado en tu billetera digital en un lapso de 9 días hábiles posteriores a la entrega.'
    },
    {
      imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Carac4-new.png',
      titulo: 'Pronto pago y disponibilidad del dinero',
      texto: 'El recaudo y pago de tus ventas puede demorarse hasta 9 días, con Triidy puedes solicitar este dinero inmediatamente se entreguen tus pedidos; así, siempre tendrás flujo de caja y tu negocio nunca pararás de crecer. En el momento que desees puedes retirar el dinero en tu banco de elección y en un rango de 24 horas en días hábiles obtendrás el débito.'
    },
    {
      imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Carac5-new.png',
      titulo: 'Transacciones',
      texto: 'En Triidy puedes enviar dinero a otros usuarios, además ho hay cobros por transferir o retirar tu dinero de la billetera; aplica términos y condiciones.' +
        '<br> Podrás obtener el reembolso de productos indemnizados; esto se realiza cuando la transportadora daña, pierde un paquete o cuando el proveedor despacha la mercancía incorrecta.'
    },
    {
      imagen: 'https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Carac6-new.png',
      titulo: 'Control y visibilidad financiera',
      texto: 'Tendrás las métricas del crecimiento de tu negocio en tiempo real, permitiendote visibilidad total sobre tus ingresos y egresos; obteniendo estadísticas detalladas sobre las ganancias de tu ecommerce.'
    }
  ]

  constructor(public router: Router, public service: ServicesService, public cookieSvc: CookieService, public snackBar: MatSnackBar) {
    super(router, service, cookieSvc, snackBar);
  }

  ngOnInit(): void {
  }

  clickM() {
    this.service.emitChange(true);
  }

  descargaWin(): void {
    window.open('https://triidyftp.s3.us-east-2.amazonaws.com/Triidy.rar', '_blank');
  }

  descargaAnd(): void {
    window.open('https://play.google.com/store/apps/details?id=app.avalon.triidy', '_blank');
  }

}
